import { Drawer, DrawerContent, DrawerOverlay, UseDisclosureReturn, VStack } from '@chakra-ui/react'
import { themeColors } from 'theme'

import { SidebarContent } from './SidebarContent'

interface CustomDrawerProps {
  sidebarOptions: UseDisclosureReturn
}

const CustomDrawer: React.FC<CustomDrawerProps> = ({ sidebarOptions: { isOpen, onClose } }) => {
  const { drawer: { bgColor } } = themeColors

  return (
    <VStack
      w={{ base: 'full' }}
      pos='sticky'
      top='4'
      h='calc(100vh - 102px)'
      bg={bgColor}
      rounded='2xl'
      mr={20}
      alignItems='center'
      mx='auto'>
      <SidebarContent />
      <Drawer isOpen={isOpen} onClose={onClose} placement='left' isFullHeight>
        <DrawerOverlay />
        <DrawerContent bg={bgColor} px={0} >
          <SidebarContent w='full' borderRight='none' />
        </DrawerContent>
      </Drawer>
    </VStack>
  )
}

export default CustomDrawer
